import React from 'react';

interface FlowHeaderProps {
  flow: any;
  orgData?: any;
}

const FlowHeader: React.FC<FlowHeaderProps> = ({ 
  flow,
  orgData
}) => {
  if (!flow) return null;
  
  // Debug logging
  console.log('FlowHeader - active_version_id:', flow.active_version_id);
  console.log('FlowHeader - orgData:', orgData);
  if (flow.active_version_id && orgData?.instance_url) {
    console.log('Salesforce URL would be:', `${orgData.instance_url}/builder_platform_interaction/flowBuilder.app?flowId=${flow.active_version_id}`);
  }
  
  return (
    <div className="bg-white shadow sm:rounded-lg mb-6">
      <div className="px-4 py-5 sm:px-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900 flex items-center">
              <span>{flow.master_label || flow.MasterLabel || flow.metadata?.MasterLabel || flow.name || flow.metadata?.FullName || flow.metadata?.DeveloperName || flow.sf_flow_id || 'Unnamed Flow'}</span>
              {flow.namespace_prefix && (
                <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {flow.namespace_prefix}
                </span>
              )}
              {flow.active_version_id && orgData?.instance_url ? (
                <a
                  href={`${orgData.instance_url}/builder_platform_interaction/flowBuilder.app?flowId=${flow.active_version_id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 text-gray-400 hover:text-blue-600 transition-colors"
                  title="Open in Salesforce"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              ) : (
                flow.active_version_id && (
                  <span className="ml-2 text-xs text-gray-400" title="Org data not loaded">
                    (SF link pending)
                  </span>
                )
              )}
            </h3>
          </div>
          <div className="flex items-center gap-3">
            {(flow.process_type || flow.metadata?.ProcessType) && (
              <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-blue-50 text-blue-700">
                {flow.process_type || flow.metadata.ProcessType}
              </span>
            )}
            <span
              className={`inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium ${
                flow.active ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
              }`}
            >
              {flow.status || (flow.active ? 'Active' : 'Inactive')}
            </span>
          </div>
        </div>
      </div>
      
      {/* Description Section */}
      {flow.description && (
        <div className="px-4 pt-2 pb-5 sm:px-6">
          <dt className="text-sm font-medium text-gray-500">Description</dt>
          <dd className="mt-1 text-sm text-gray-900">{flow.description}</dd>
        </div>
      )}
    </div>
  );
};

export default FlowHeader;